/**
 * Project Consultation & Quote Inquiry Modal
 */
export function initContactModal() {
  const modalBackdrop = document.getElementById('contactModal');
  const modalCloseBtn = document.getElementById('contactModalClose');
  const openButtons = document.querySelectorAll('[data-open-modal="contact"]');
  const form = document.getElementById('contactForm');
  const successNotice = document.getElementById('contactSuccessNotice');

  if (!modalBackdrop) return;

  function openModal() {
    modalBackdrop.classList.add('is-active');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    modalBackdrop.classList.remove('is-active');
    document.body.style.overflow = '';
  }

  openButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();
      openModal();
    });
  });

  if (modalCloseBtn) {
    modalCloseBtn.addEventListener('click', closeModal);
  }

  modalBackdrop.addEventListener('click', (e) => {
    if (e.target === modalBackdrop) {
      closeModal();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && modalBackdrop.classList.contains('is-active')) {
      closeModal();
    }
  });

  if (form) {
    form.addEventListener('submit', (e) => {
      e.preventDefault();
      const submitBtn = form.querySelector('button[type="submit"]');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Transmitting...';
      }

      setTimeout(() => {
        form.style.display = 'none';
        if (successNotice) {
          successNotice.style.display = 'block';
        }
      }, 900);
    });
  }
}

